import { render, staticRenderFns } from "./wxkfSet.vue?vue&type=template&id=32781967&scoped=true&"
import script from "./wxkfSet.vue?vue&type=script&lang=js&"
export * from "./wxkfSet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32781967",
  null
  
)

export default component.exports